import React from 'react';
import { Router, Route } from 'react-router-dom';
import { GlobalStyle } from '../Universal/style';
import Wrapper from '../Wrapper';

import * as routes from '../../constants/routes';
import history from '../../constants/history';

const App = () => (
  <Router history={history}>
    <GlobalStyle />
    <Route path={routes.MAIN} render={() => <Wrapper />} />
  </Router>
);

export default App;
